/**
 * Session-scoped client caches that must not leak across auth users in the same tab.
 */
import {
    clearAllAssistantChatStates,
    clearAssistantChatState,
    clearAssistantChatStatesForOtherUsers,
} from '@/lib/assistantChatPersistence';
import { storage } from '@/utils/storage';

const FIREBASE_SESSION_KEYS = [
    'firebase_google_id_token',
    'firebase_google_email',
    'firebase_facebook_id_token',
    'firebase_facebook_email',
    'firebase_phone_id_token',
] as const;

export function clearFirebaseAuthSessionKeys(): void {
    for (const key of FIREBASE_SESSION_KEYS) {
        storage.session.removeItem(key);
    }
}

/** Clear caches tied to the previous auth session before switching users. */
export function clearAuthScopedSessionCaches(options?: {
    previousUserId?: string | null;
    clearAllAssistant?: boolean;
}): void {
    if (options?.clearAllAssistant) {
        clearAllAssistantChatStates();
    } else if (options?.previousUserId) {
        clearAssistantChatState(options.previousUserId);
    }

    clearFirebaseAuthSessionKeys();
    storage.session.removeItem('push_auto_synced');
}

/** After login: drop guest/other-user assistant state; keep only the active account. */
export function isolateSessionCachesForUser(userId: string): void {
    clearAssistantChatState('guest');
    clearAssistantChatStatesForOtherUsers(userId);
}
